import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'

import useStyles from './useStyles'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getApplicationInstanceEAuthz } from '../../../redux/actions/eAuthz'
import { BoxDetails } from './Boxes/Details'
import { BoxModules } from './Boxes/Modules'
import { BoxTopes } from './Boxes/Params'
import { BoxOrganization } from './Boxes/Organization'
import { BoxSuborganization } from './Boxes/Suborganization'
import BreadcrumbsComponent from '../Breadcrumbs/Breadcrumbs'

export const InstancesById = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id } = useParams()

  const [item, setitem] = useState(null)
  const [loading, setLoading] = useState(false)

  const getInstance = async () => {
    setLoading(true)
    const response = await dispatch(getApplicationInstanceEAuthz(id))
    setitem(response)
  }

  useEffect(async () => {
    setLoading(true)
    await getInstance()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Información sobre la Instancia de aplicación
        </Typography>
      </div>
      {/* <div
        className={classes.buttonVerifyStateMEApp}
        onClick={() => (window.location.href = `/organizations/${id}/statusME`)}
      >
        <ManageSearchIcon style={{ color: '#008471' }} />
        <Typography className={classes.subtitle}>

        </Typography>
      </div>

      <div
        className={classes.buttonVerifyStateMEApp}
        onClick={() =>
          (window.location.href = `/suborganizations/${item.baseSuborganizationId}/statusStorage`)
        }
      >
        <RuleFolderIcon style={{ color: '#008471' }} />
        <Typography className={classes.subtitle}>

        </Typography>
      </div> */}
      {item && (
        <>
          <BoxDetails item={item} />
          <BoxOrganization item={item} />
          <BoxSuborganization item={item} />
          <BoxModules modules={item.appModules} />
          <BoxTopes appParameters={item.appParameters} />
        </>
      )}
    </div>
  )
}
